import { createContext, useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";

import { useUserContext } from "./UserContextProvider";

export const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const { currentUserInfo } = useUserContext();
  const [socketConnectionStatus, setSocketConnectionStatus] = useState(false);
  const socketRef = useRef(null); // Store socket instance in a ref

  useEffect(() => {
    if (!currentUserInfo?.socketServerUrl) return;

    // Prevent multiple connections
    if (socketRef.current) {
      // console.log("Socket already initialized");
      return;
    }

    const newSocket = io(currentUserInfo?.socketServerUrl, {
      transports: ["websocket"],
      reconnection: true,
    });

    socketRef.current = newSocket; // Store in ref

    newSocket.on("connect", () => {
      // console.log("Connected to WebSocket");

      setSocketConnectionStatus(true);
      newSocket.emit("join", {
        phoneId: currentUserInfo?.wabPhoneId,
        emailId: currentUserInfo?.emailId,
      });
    });

    newSocket.on("disconnect", (reason) => {
      // console.warn("Socket disconnected, reason:", reason);

      newSocket.emit("remove", {
        phoneId: currentUserInfo?.wabPhoneId,
        emailId: currentUserInfo?.emailId,
      });
      setSocketConnectionStatus(false);
    });

    newSocket.on("connect_error", (error) => {
      // console.error("Socket.IO error:", error);

      setSocketConnectionStatus(false);
    });

    return () => {
      // console.log("Cleaning up socket...");

      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUserInfo?.socketServerUrl]); // Only run when URL changes

  return (
    <SocketContext.Provider
      value={{ socketConnection: socketRef.current, socketConnectionStatus }}
    >
      {children}
    </SocketContext.Provider>
  );
};
